module.exports = __webpack_public_path__ + "img/game_img3.f1640505.jpg";